import { useQuery } from "@tanstack/react-query";

import { toApiFilterParams } from "./fetchNotifications";
import { notificationQueryKeys } from "./query-keys";
import { NOTIFICATION_FILTER_OPTIONS_STALE_TIME_MS, notificationsUrl } from "../constants";
import { notificationFilterOptionsSchema } from "../schemas";
import type { NotificationFilterOptionsParams } from "../types";

import { instance } from "@/lib/axios/instance";

export function useNotificationFilters(params: NotificationFilterOptionsParams) {
  return useQuery({
    queryKey: notificationQueryKeys.filter(params),
    queryFn: async () => {
      const { data } = await instance.get<unknown>(notificationsUrl("Filters"), {
        params: toApiFilterParams(params),
      });
      return notificationFilterOptionsSchema.parse(data);
    },
    staleTime: NOTIFICATION_FILTER_OPTIONS_STALE_TIME_MS,
  });
}
